function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex';
import Somos1Service from '@/apps/customer-insigths/services/somos1_service';
import { mapState } from 'vuex';
import Somos1DataEntryService from '@/apps/customer-insigths/services/somos1_data_entry_service';
import tasks from '@/js/tasks';
import { GA_EVENTS } from '@/js/constants';
export default {
  name: 'ReportList',
  data: function data() {
    return {
      DIALOG_INFO_VIEW: 'DIALOG_INFO_VIEW',
      keyDashboardsList: 0,
      items: [],
      headers: [{
        value: 'report.name',
        text: 'Nombre'
      }, {
        value: 'last_update',
        text: 'Última actualización'
      }, {
        value: 'report.description',
        text: 'Descripción'
      }, {
        value: 'report.region.region',
        text: 'Región'
      }, {
        value: 'actions',
        text: ''
      }],
      send_token: false,
      agreement_text: '',
      color: 'custom',
      decline: false,
      company_code: '',
      SOMOS1: 'Somos1',
      canDownload: true,
      hovering: null,
      last_updated_contact: '',
      last_updated_date: ''
    };
  },
  created: function created() {
    this.getReports();
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName'])), {}, {
    getClassTable: function getClassTable() {
      if (this.filter_enabled) {
        return 'col-md-9 col-sm-12';
      } else {
        return 'col-sm-12';
      }
    },
    last_update_message: function last_update_message() {
      if (this.companyCode === '032') {
        return 'Último mes y año registrado por el área de Planeamiento financiero en las empresas';
      } else {
        return 'Último mes y año registrado por el área de Planeamiento financiero para su empresa.';
      }
    }
  }),
  mounted: function mounted() {},
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['setShowLoading'])), {}, {
    getReports: function () {
      var _getReports = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var params, response, visitasReportes, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.setShowLoading(true);
              params = {
                is_admin: this.userHasRole(this.rolesINCA.INSIGHTS_ADMIN),
                section: this.SOMOS1
              };
              _context.p = 1;
              _context.n = 2;
              return Somos1Service.getReportsAssignments(params);
            case 2:
              response = _context.v;
              visitasReportes = [];
              response.data.forEach(function (item) {
                var report = item.report;
                var tags = report.tags;
                item.last_update = '';
                if (Array.isArray(tags) && tags.includes('Visitas')) {
                  visitasReportes.push(item);
                }
              });
              console.log(visitasReportes, 'visitasReportes');
              this.items = visitasReportes;
              this.keyDashboardsList += 1;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.error(_t);
            case 4:
              _context.p = 4;
              this.setShowLoading(false);
              this.updateLastUpdates();
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function getReports() {
        return _getReports.apply(this, arguments);
      }
      return getReports;
    }(),
    onVer: function onVer(item) {
      var roles = this.userInfo.userRoles;
      var encontradoUser = roles.includes('insights_user_somos1');
      var encontradoBusiness = roles.includes('insights_business_user');
      var rol = encontradoUser ? encontradoBusiness ? 'insights_user_somos1' : 'insights_user_somos1' : encontradoBusiness ? 'insights_business_user' : null;
      if (this.$gtm.enabled() && window.dataLayer) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: GA_EVENTS.CLICK_REPORT,
          region: _typeof(item.report.region) === 'object' ? item.report.region.region : item.report.region,
          type: 'visitor_presentation',
          company_report: item.domain,
          company_code: this.companyCode,
          hash_email: this.stringToHash(userInfo.email),
          rol: rol,
          'module': 'customer_insights',
          report_id: item.report_id
        });
      }
      this.$router.push({
        name: 'Somos1',
        params: {
          report_id: item.report.document_id,
          no_require_agreement: true,
          link: 'visitor_presentation',
          title: 'Visitas'
        }
      });
    },
    updateLastUpdates: function updateLastUpdates() {
      var _this = this;
      this.items.forEach(function (item) {
        _this.post_last_updates(item.report.region.id_region_dataentry).then(function (resolvedValue) {
          item.last_update = resolvedValue.message;
          item.last_user = resolvedValue.last_user;
        }).catch(function (error) {
          console.log('An error occurred:', error);
        });
      });
    },
    post_last_updates: function () {
      var _post_last_updates = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(id_region) {
        var params, response, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.setShowLoading(true);
              params = {
                id_region: id_region
              };
              _context2.p = 1;
              _context2.n = 2;
              return Somos1DataEntryService.postLastUpdate(params);
            case 2:
              response = _context2.v;
              if (!(response.success && response.code === 200)) {
                _context2.n = 4;
                break;
              }
              if (!(response.data.max_month !== null)) {
                _context2.n = 3;
                break;
              }
              return _context2.a(2, {
                'message': response.data.max_month + ' del ' + response.data.max_year,
                'last_user': response.data.last_user
              });
            case 3:
              return _context2.a(2, {
                'message': 'Todavia no existe información',
                'last_user': ''
              });
            case 4:
              _context2.n = 6;
              break;
            case 5:
              _context2.p = 5;
              _t2 = _context2.v;
              console.error(_t2);
              tasks.toast.error('error');
            case 6:
              _context2.p = 6;
              this.keyDashboardsList += 1;
              this.setShowLoading(false);
              return _context2.f(6);
            case 7:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 5, 6, 7]]);
      }));
      function post_last_updates(_x) {
        return _post_last_updates.apply(this, arguments);
      }
      return post_last_updates;
    }(),
    onDownload: function onDownload(item) {
      var _this2 = this;
      var params = {
        'id_region_dataentry': item.report.region.id_region_dataentry,
        'region': item.report.region.region
      };
      Somos1DataEntryService.postDownloadDataByRegion(params).then(function (response) {
        if (response) {
          var url = URL.createObjectURL(new Blob([response.data], {
            type: 'application/vnd.ms-excel'
          }));
          var link = document.createElement('a');
          link.href = url;
          var today = new Date();
          var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
          var time = today.getHours() + '-' + today.getMinutes() + '-' + today.getSeconds();
          var filename = 'dataentry-' + item.report.region.region + '-' + date + '-' + time + '.xlsx';
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          _this2.loading = false;
          var roles = _this2.userInfo.userRoles;
          var encontradoUser = roles.includes('insights_user_somos1');
          var encontradoBusiness = roles.includes('insights_business_user');
          var rol = encontradoUser ? encontradoBusiness ? 'insights_user_somos1' : 'insights_user_somos1' : encontradoBusiness ? 'insights_business_user' : null;
          console.log('rol:', rol);
          var report = item.report;
          if (_this2.$gtm.enabled() && window.dataLayer) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: GA_EVENTS.DOWNLOAD_REPORT,
              region: _typeof(report.region) === 'object' ? report.region.region : report.region,
              type: 'somos1_report',
              company_code: _this2.companyCode,
              hash_email: _this2.stringToHash(userInfo.email),
              rol: rol,
              'module': 'customer_insights',
              report_id: item.report_id
            });
          }
        }
      });
    },
    copyToClipboard: function () {
      var _copyToClipboard = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(text) {
        var _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return navigator.clipboard.writeText(text);
            case 1:
              this.$toast('Copiado al portapapeles'); // Si estás usando un sistema de toast.
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              this.$toast('Error al copiar al portapapeles'); // Ajusta según tu sistema de mensajes.
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function copyToClipboard(_x2) {
        return _copyToClipboard.apply(this, arguments);
      }
      return copyToClipboard;
    }(),
    verInfo: function verInfo(item) {
      console.log(item);
      this.last_updated_contact = item.last_user;
      this.last_updated_date = item.last_update;
      this.openDialog(this.DIALOG_INFO_VIEW);
    },
    openDialog: function openDialog(modalName) {
      this.$refs[modalName].onOpen();
    }
  })
};